import { Creative } from '@lib/iab/iab-vast-model';

import createCompanionAds from './companion-ads';
import createCreativeExtension from './creative-extension';
import createLinear from './linear';
import createNonLinearAds from './non-linear-ads';
import createUniversalAdId from './universal-ad-id';

interface UnmarshalerNode {
    _value: unknown;
    [key: string]: unknown;
}

interface ParseOptions {
    errorHandler: {
        tryRecover: (error: Error) => void;
    };
}

const createCreative = (
    $creative: UnmarshalerNode,
    options: ParseOptions
): Creative => {
    const creative = new Creative();
    creative.id = $creative.id as string;
    creative.sequence = $creative.sequence as number;
    // VAST3 XSD specifies AdID and that seems to be what parsers have agreed on
    creative.adID = ($creative.AdID ||
        $creative.adID ||
        $creative.adId) as string;
    creative.apiFramework = $creative.apiFramework as string;

    if ($creative.universalAdId != null) {
        creative.universalAdId = createUniversalAdId(
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            $creative.universalAdId as any
        );
    }

    if (
        $creative.creativeExtensions != null &&
        ($creative.creativeExtensions as UnmarshalerNode).creativeExtension
    ) {
        creative.extensions.push(
            ...(
                ($creative.creativeExtensions as UnmarshalerNode)
                    .creativeExtension as UnmarshalerNode[]
            ).map((extension: UnmarshalerNode) =>
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                createCreativeExtension(extension as any)
            )
        );
    }

    if ($creative.linear != null) {
        creative.linear = createLinear($creative, options);
    } else if ($creative.nonLinearAds != null) {
        creative.nonLinearAds = createNonLinearAds($creative);
    }

    if ($creative.companionAds != null) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        creative.companionAds = createCompanionAds($creative as any);
    }

    if (
        creative.linear == null &&
        creative.nonLinearAds == null &&
        creative.companionAds == null
    ) {
        options.errorHandler.tryRecover(new Error('Creative has no ads'));
    }

    return creative;
};

export default createCreative;
